module.exports = __webpack_public_path__ + "img/tonggao.ad968cd6.png";